import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _get from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/editorui/editoruiview
 */

/* globals document */
import View from "../view";
import Template from "../template";
import "../../theme/components/editorui/editorui.css";
/**
 * The editor UI view class. Base class for the editor main views.
 *
 * @extends module:ui/view~View
 */

var EditorUIView = /*#__PURE__*/function (_View) {
  _inherits(EditorUIView, _View);

  var _super = _createSuper(EditorUIView);

  /**
   * Creates an instance of the editor UI view class.
   *
   * @param {module:utils/locale~Locale} [locale] The locale instance.
   */
  function EditorUIView(locale) {
    var _this;

    _classCallCheck(this, EditorUIView);

    _this = _super.call(this, locale);
    /**
     * Collection of the child views, detached from the DOM
     * structure of the editor, like panels, icons etc.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection} #body
     */

    _this.body = _this.createCollection();
    /**
     * The element holding elements of the 'body' region.
     *
     * @private
     * @member {HTMLElement} #_bodyCollectionContainer
     */

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(EditorUIView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(EditorUIView.prototype), "render", this).call(this);

      this._renderBodyCollection();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this._bodyCollectionContainer.remove();

      return _get(_getPrototypeOf(EditorUIView.prototype), "destroy", this).call(this);
    }
    /**
     * Creates and appends to `<body>` the {@link #body} collection container.
     *
     * @private
     */

  }, {
    key: "_renderBodyCollection",
    value: function _renderBodyCollection() {
      var locale = this.locale;
      var bodyElement = this._bodyCollectionContainer = new Template({
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-reset_all', 'ck-body', 'ck-rounded-corners'],
          dir: locale.uiLanguageDirection
        },
        children: this.body
      }).render();
      document.body.appendChild(bodyElement);
    }
  }]);

  return EditorUIView;
}(View);

export { EditorUIView as default };